import { render, staticRenderFns } from "./preview_3.vue?vue&type=template&id=3077d76b&scoped=true"
import script from "./preview_3.vue?vue&type=script&lang=js"
export * from "./preview_3.vue?vue&type=script&lang=js"
import style0 from "./preview_3.vue?vue&type=style&index=0&id=3077d76b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3077d76b",
  null
  
)

export default component.exports